import { useMemo } from 'react';

import { applyAccessibilityPreferences } from '@/lib/accessibility/apply-accessibility-preferences';
import type { AccessibilityPreferences } from '@/lib/accessibility/types';
import { createUnitSiteTheme } from '@/styles/theme/create-unit-site-theme';
import type { SiteThemeConfig } from '@/types/database';

// The single place both the published site (PublicSite.tsx) and the style
// editor's accessibility preview (PreviewCard.tsx) derive a themed render
// from: the unit's saved theme_config, with the visitor's (or editor's
// preview) accessibility preferences layered on top. Never bypasses
// createUnitSiteTheme — the base theme is always computed first.
export function useEffectiveWebsiteTheme(themeConfig: SiteThemeConfig, preferences: AccessibilityPreferences) {
  return useMemo(
    () => applyAccessibilityPreferences(createUnitSiteTheme(themeConfig), preferences),
    [themeConfig, preferences]
  );
}
